import {
  ActionTypes,
  IBannerApiData,
  TypeKeys
} from '../actions/marketing/banner'

export interface IState {
  readonly banners: IBannerApiData[]
}

const initialState: IState = {
  banners: []
}

export const reducer = (state = initialState, action: ActionTypes): IState => {
  switch (action.type) {
    case TypeKeys.GET_BANNER_SUCCESS:
      const banners = action.payload
      return {
        ...state,
        banners
      }

    default:
      return state
  }
}
